import { useState, useEffect, useCallback } from 'react'
import { tasksApi } from '../api/client'

export function useTasks(options = {}) {
  const { projectId, assigneeId, status, myTasks } = options
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchTasks = useCallback(async () => {
    try {
      setLoading(true)
      const params = {}
      if (projectId) params.project_id = projectId
      if (assigneeId) params.assignee_id = assigneeId
      if (status) params.status = status
      if (myTasks) params.my_tasks = true
      const response = await tasksApi.list(params)
      // Ensure we always have an array, even if API returns unexpected data
      setTasks(Array.isArray(response.data) ? response.data : [])
      setError(null)
    } catch (err) {
      setError(err.message || 'Failed to fetch tasks')
    } finally {
      setLoading(false)
    }
  }, [projectId, assigneeId, status, myTasks])

  useEffect(() => {
    fetchTasks()
  }, [fetchTasks])

  const createTask = async (data) => {
    const response = await tasksApi.create(data)
    setTasks(prev => [...prev, response.data])
    return response.data
  }

  const updateTask = async (taskId, data) => {
    const response = await tasksApi.update(taskId, data)
    setTasks(prev => prev.map(t => t.id === taskId ? response.data : t))
    return response.data
  }

  const deleteTask = async (taskId) => {
    await tasksApi.delete(taskId)
    setTasks(prev => prev.filter(t => t.id !== taskId))
  }

  const moveTask = async (taskId, columnId, position) => {
    const response = await tasksApi.move(taskId, columnId, position)
    setTasks(prev => prev.map(t => t.id === taskId ? response.data : t))
    return response.data
  }

  return {
    tasks,
    loading,
    error,
    refresh: fetchTasks,
    createTask,
    updateTask,
    deleteTask,
    moveTask,
  }
}
